/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { Image, Container, Row, Col } from "react-bootstrap";
import * as S from "./styles";

export interface IImageFeatureItem {
  icon: string | any;
  title: string;
  description?: string;
}

export interface IImageFeatureProps {
  imageFeatureSectionId?: string;
  imageFeatureTitle?: string;
  imageFeatureDescription?: string;
  imageFeatureImage?: string;
  imageFeatureFeatures?: IImageFeatureItem[];
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const ImageFeature = ({
  imageFeatureSectionId,
  imageFeatureTitle,
  imageFeatureDescription,
  imageFeatureImage,
  imageFeatureFeatures,
}: IImageFeatureProps) => {
  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === "string") {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={50}
            height={50}
            className=" p-1"
            style={{ objectFit: "contain" }}
          />
        );
      } else {
        const HeroIcon = require("@heroicons/react/solid");
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className="icon icon-md text-secondary"
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(
        <Icon key={`hero-icon-2`} className="icon icon-md text-secondary" />
      );
    }
    return _icon;
  };

  const _renderTitleSectionIf = () => {
    if (imageFeatureTitle) {
      return (
        <Col xs={12} className="text-center">
          <h2 className="px-lg-5">
            {imageFeatureTitle}
            {imageFeatureDescription && (
              <p className="lead px-lg-10">{imageFeatureDescription}</p>
            )}
          </h2>
        </Col>
      );
    }
  };

  const _renderImageIf = () => {
    if (imageFeatureImage) {
      return (
        <Col xs={12}>
          <Image
            src={imageFeatureImage}
            alt="image-feature-image"
            style={S.imageStyle}
          />
        </Col>
      );
    }
  };

  const _renderFeaturesIf = () => {
    return imageFeatureFeatures?.map((feature, index) => {
      if (feature?.icon) {
        return (
          <Col xs={6} md={3} className="text-center mb-4">
            <div className="icon-shape bg-white shadow-lg border-light rounded-circle mb-4">
              {_getIcon(feature.icon)}
            </div>
            {feature?.title && <h3 className="fw-bolder">{feature.title}</h3>}
            {feature?.description && (
              <p className="text-gray">{feature?.description}</p>
            )}
          </Col>
        );
      }
    });
  };

  return (
    <div className="section pt-0" id={imageFeatureSectionId}>
      <Container className="mt-n10 mt-lg-n12 z-2">
        <Row className="justify-content-center">
          {_renderTitleSectionIf()}
          {_renderImageIf()}
        </Row>
        <Row className="justify-content-center mt-5 mt-lg-6">
          {_renderFeaturesIf()}
        </Row>
      </Container>
    </div>
  );
};

ImageFeature.defaultProps = {
  imageFeatureSectionId: "image-feature",
};
